// Pilot toggles for the "write a product experience" popup shown after a
// seller deactivates/deletes a (sold) listing. Scope (which users / which
// bazaar categories) is decided on the backend; these flags only control when
// the frontend is allowed to open the popup.
export const SELL_EXPERIENCE_POPUP_ENABLED = true;
export const SELL_EXPERIENCE_POPUP_ON_DEACTIVATE = true;
export const SELL_EXPERIENCE_POPUP_ON_DELETE = true;
